import { CsvColumnSeparator } from '../../enums/file-reader/csv-column-separators';
import { CsvColumnProps } from './csv-column-props';
import { FileReaderBase } from './file-reader-base';

/**
 * Reader configuration for CSV files. Extends FileReaderBase with CSV-specific
 * column mapping, row start, and delimiter settings.
 */
export class CsvReaderProps extends FileReaderBase {
	/**
	 * Optional column label definitions. Maps column indexes to names.
	 * If empty, column headers are read from the first data row.
	 * @default []
	 */
	rowConfig: CsvColumnProps[] = [];

	/**
	 * Zero-based index of the first data row (skips header rows above this index).
	 * @default 0
	 */
	dataRowStart = 0;

	/**
	 * Column delimiter. 0=comma, 1=semicolon, 2=pipe, 3=colon, 4=period.
	 * @default CsvColumnSeparator[',']
	 */
	columnSeparator = CsvColumnSeparator[','];

	constructor(init?: Partial<CsvReaderProps>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}
}
